module.exports = __webpack_public_path__ + "public/img/slider/slide-2.png";